module.exports = __webpack_public_path__ + "static/media/image-4.a00d8175.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FBGroup/image-4.png
// module id = 460
// module chunks = 0